<template>
  <div id="landing">
    <div class="landing-title-wrapper">
      <div class="isuma-logo-container">
        <a href="http://isuma.tv" class="href"><img class="isuma-logo" src="@/assets/images/Isumalogo.svg"/></a>
      </div>
      <h1 class="landing-title title-in">ᐊᐅᓪᓚᕐᓯᒪᓪᓗᑕ ᐅᓂᒃᑳᕐᑐᖅ ᓄᐊ ᐱᐅᒑᑦᑐᒃ</h1>
      <h1 class="landing-title title-rn">On the Land with Noah Piugattuk</h1>
      <div class="landing-links-container">
        <div v-if="$store.state.eventId === 'welcome'" class="landing-links">
          <div @click="next('iu')" class="landing-link link-in">
            <div class="link-item">ᓈᓚᒃᓗᒋᑦ ᐅᓂᒃᑳᖏᑦ</div>
            <div class="link-item">ᐊᒻᒪᓗ ᐱᓱᖃᑕᐅᓗᑎᑦ ᓄᓇᒥ</div>
          </div>
          <img src="@/assets/images/chapter.svg"/>
          <div @click="next('en')" class="landing-link link-rn">
            <div class="link-item">Listen to his story</div>
            <div class="link-item">and walk the land</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'landing',
  methods: {
    next (locale) {
      if (this.$i18n.locale === locale) {
        this.$store.dispatch('next')
      } else {
        document.querySelector('.events').style.scrollBehavior = 'auto'
        this.$i18n.locale = locale
        const newLang = locale === 'iu' ? 'Inuktitut' : 'English'
        this.$store.commit('setLang', newLang)
        window.location.href = '#introduction'
        window.localStorage.setItem('lang', newLang)
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
  #landing {
    height: 100%;
    .isuma-logo-container {
      position: absolute;
      top: 48px;
      display: flex;
      justify-content: center;
    }
    .landing-title-wrapper {
      width: 100vw;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .landing-title {
        margin: 4px 0;
      }
      .landing-title.title-in {
        font-family: Pigiarniq;
        font-size: 34px;
        @media only screen and (max-width: 768px) {
          font-size: 24px;
        }
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: 3px;
        text-align: center;
        color: #9a6969;
      }
      .landing-title.title-rn {
        font-family: CAPUTTRIAL;
        font-size: 42px;
        @media only screen and (max-width: 768px) {
          font-size: 32px;
        }
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: center;
        color: #244a56;
      }
      .landing-links-container {
      position: absolute;
      bottom: 64px;
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
      .landing-links {
        display: flex;
        flex-direction: row;
        text-transform: uppercase;
        .landing-link {
          display: flex;
          flex-direction: column;
          .link-item {
            border-bottom: solid 2px #9a6969;
            cursor: pointer;
            align-self: center;
          }
        }
        .landing-link:hover {
          .link-item {
            color: white;
            background-color: #9a6969
          }

        }
        .link-in {
          font-family: Pigiarniq-Bold;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          text-align: center;
          color: #18333c;
        }
        .link-rn {
          font-family: Rubik-Medium;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          text-align: center;
          color: #18333c;
        }
        img {
          width: 24px;
          height: 24px;
          margin: 16px;
        }
      }
      @media only screen and (max-width: 768px) {
        // display: none;
      }
    }
  }

  }
</style>
